import { EpiContent } from '@api/types';
import { BlockContainer, ContentArea } from '@components';
import { Box, Grid, styled } from '@mui/material';
import { colors } from '@themes/colors';
import { breakpoints } from '@themes/theme.helpers';
import { ContentListItemBlock } from '../ContentListItemBlock/ContentListItemBlock';

export type ContentListBlockProps = {
  content?: EpiContent;
  backgroundColor?: string;
  contentItemLinkText?: string;
  [key: string]: any;
};

const ContentListBlockWrapper = styled(Box)<{ backgroundColor: string }>`
  background-color: ${(props) => props.backgroundColor};
  padding: 16px 0;
  .content-list-item-title,
  .content-list-item-description {
    color: ${(props) => (props.backgroundColor === 'black' ? colors.secondary.light : 'inherit')};
  }
  ${breakpoints.up('md')} {
    padding: 40px 0;
  }
`;

export const ContentListBlock: React.FC<ContentListBlockProps> = ({
  content,
  backgroundColor = 'transparent',
  contentItemLinkText,
}: ContentListBlockProps) => {
  return (
    <ContentListBlockWrapper backgroundColor={backgroundColor}>
      <BlockContainer>
        <Grid
          container
          spacing={{
            xs: 2,
            md: 8,
          }}
        >
          <ContentArea
            content={content}
            wrapperComponent={(props) => (
              <ContentListItemBlock contentItemLinkText={contentItemLinkText} {...props} />
            )}
          />
        </Grid>
      </BlockContainer>
    </ContentListBlockWrapper>
  );
};
